import { useAuthUser, useSignIn } from 'react-auth-kit'
import { expirationFromNow, refreshToken } from './sign-in/SignIn.state'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { getRefreshTokenInterval } from './lib/token'

const ForceRefreshToken = () => {
    const auth = useAuthUser()()
    const signIn = useSignIn()
    const history = useHistory()

    useEffect(() => {
        let refreshed = false
        const doRefresh = async () => {
            // When the user hits on refresh button while they're logged in,
            // refresh the token immediately so that it will execute refresh token interval from fresh.
            if (
                // execute then the effect has not been called before
                !refreshed && 
                // make sure the user is logged in
                auth?.user_id && 
                // only execute when the token will be expired before the existing refresh token interval kicks in
                expirationFromNow(auth?.token) < getRefreshTokenInterval(auth?.lifespan) && 
                // only execute when it has refresh token.
                auth?.refresh_token
            ) {
                try {
                    const authPayload = await refreshToken({
                        authToken: auth?.token,
                        refreshToken: auth?.refresh_token,
                        currentAuthState: auth,
                        isRefresh: false,
                    })
                    if (authPayload) {
                        // simulate sign in process so that react-auth-kit will trigger syncToken
                        signIn(authPayload)
                        window.dispatchEvent(new StorageEvent("auth-storage"))
                    }
                } catch (e) {
                    history.replace({
                        pathname: '/sign-in',
                        search: '?expired',
                    })
                }
            }
        }
        doRefresh()
        return () => {
            // Clean up effect
            refreshed = true
        }
    }, [auth, signIn, history])
    return null
}

export default ForceRefreshToken